import React, { forwardRef } from "react";
import { MultiSelect } from "primereact/multiselect";
import styles from "./index.module.scss";

interface MultiSelectProps {
  value?: any[];
  showClear: boolean;
  onChange?: any;
  options?: (string | object)[];
  optionLabel?: string;
  placeholder?: string;
  className?: string;
  panelClassName?: string;
  tabIndex?: number;
  selectColor?: boolean;
  disabled?: boolean;
  name?: string;
  maxSelectedLabels?: number;
  showTooltip?: boolean;
  filter?: boolean;
}

const MultiSelectC = forwardRef((props: MultiSelectProps, ref: any) => {
  const {
    value,
    onChange,
    options,
    optionLabel,
    placeholder,
    className,
    panelClassName,
    tabIndex,
    selectColor,
    name,
    disabled,
    maxSelectedLabels = 2,
    filter = false
  } = props;

  const hasValue = !!value && value.length > 0;

  return (
    <div
      className={`${styles.multiSelectBox} ${selectColor && hasValue ? styles.selected : ""}`}
    >
      <MultiSelect
        disabled={disabled}
        ref={ref}
        value={value}
        onChange={onChange}
        name={name}
        options={options}
        optionLabel={optionLabel}
        placeholder={placeholder}
        className={className}
        panelClassName={`${panelClassName} ${styles.panelClassName}`}
        tabIndex={tabIndex || 1}
        showClear={false}
        maxSelectedLabels={maxSelectedLabels}
        display="chip"
        selectedItemsLabel={`{0} items selected`}
        filter={filter}
      />
    </div>
  );
});

export default React.memo(MultiSelectC);
